var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E5E5E5"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M14 1l1 1-6 6 6 6-1 1-6-6-6 6-1-1 6-6-6-6 1-1 6 6 6-6z","transform":"translate(-188 -1031) translate(-23) translate(39 1019) translate(172 12)"})))))));
}

CloseIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
